import { render, staticRenderFns } from "./addSmsTemplate.vue?vue&type=template&id=5a13d871"
import script from "./addSmsTemplate.vue?vue&type=script&lang=js"
export * from "./addSmsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports